// src/utils/FieldInput.js
import React from "react";
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  Stack,
  Select,
  MenuItem
} from "@mui/material";

export default function FieldInput({ field, roleForm, onChange, errors = {} }) {  // ADD errors = {}
  const {
    label,
    name,
    type = "number",
    options,
    step,
    anyFlag,    // e.g. "suitOneAny"
    maxName     // e.g. "suitTwo"
  } = field;

  // Determine whether "Any" is selected
  const anySelected = roleForm[anyFlag] ?? true;

  // clamp for numeric inputs
  const clampValue = (raw) => {
    let num = parseFloat(raw);
    if (isNaN(num)) num = 0;
    return Math.min(100, Math.max(0, num));
  };

  // wrapped onChange for numeric fields
  const handleNumberChange = (e) => {
    const { name: fieldName, value } = e.target;
    const clamped = clampValue(value);
    onChange({ target: { name: fieldName, value: clamped, type: "number" } });
  };

  // Dropdown case
  if (type === "select") {
    return (
      <FormControl fullWidth>
        <FormLabel>{label}</FormLabel>
        <Select
          name={name}
          value={roleForm[name] || ""}
          onChange={onChange}
          size="small"
        >
          {options.map((o) => (
            <MenuItem key={o} value={o}>
              {o}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }

  // Range case: radio on top, inputs below when "Specify"
  return (
    <FormControl component="fieldset" fullWidth>
      <FormLabel>{label}</FormLabel>

      {/* 1) Radio row */}
      <Stack direction="row" alignItems="center" spacing={2} mt={1}>
        <RadioGroup
          row
          name={anyFlag}
          value={anySelected ? "any" : "range"}
          onChange={(e) =>
            onChange({
              target: {
                name: anyFlag,
                value: e.target.value === "any",
                type: "checkbox",
              },
            })
          }
        >
          <FormControlLabel value="any" control={<Radio />} label="Any" />
          <FormControlLabel
            value="range"
            control={<Radio />}
            label="Specify"
          />
        </RadioGroup>
      </Stack>

      {/* 2) Inputs row, only when "Specify" */}
      {!anySelected && (
        <Stack direction="row" spacing={1} mt={1}>
          {/* Min input */}
          <TextField
            label="From"
            name={name}
            type="number"
            value={roleForm[name] ?? ""}
            onChange={handleNumberChange}
            inputProps={{ min: 0, max: 100, step }}
            size="small"
            fullWidth
            error={!!errors[name]}        // ADD THIS
            helperText={errors[name]}     // ADD THIS
          />

          {/* Max input */}
          <TextField
            label="To"
            name={maxName}
            type="number"
            value={roleForm[maxName] ?? ""}
            onChange={handleNumberChange}
            inputProps={{ min: 0, max: 100, step }}
            size="small"
            fullWidth
            error={!!errors[name]}        // ADD THIS (use same error as min)
            helperText={errors[name]}     // ADD THIS (use same error as min)
          />
        </Stack>
      )}
    </FormControl>
  );
}